import React from 'react';
import { useGeoAccess } from '../hooks/useGeoAccess';

/**
 * Shows the normal site to allowed visitors (Ventura County, Los Angeles
 * County, Oregon), crawlers, and anyone whose
 * location can't be determined. The site renders immediately while the check
 * runs, so allowed visitors see no delay or layout change.
 */
export function GeoGate({
  children
}: {
  children: React.ReactNode;
}) {
  const status = useGeoAccess();
  if (status !== 'blocked') return <>{children}</>;
  return <main className="min-h-screen w-full bg-black text-white flex items-center justify-center px-6" data-id="element-199" data-mp="39aoa38odv2tu">
      <div className="max-w-xl text-center" data-id="element-200" data-mp="3nafjew3yfv1i">
        <p className="text-3xl sm:text-4xl font-black uppercase tracking-tight" data-id="element-201" data-mp="3nb8to724h2oe">
          <span className="text-white" data-id="element-202" data-mp="3j7j7tpcu0z72">Mike's</span>{' '}
          <span className="text-red-600" data-id="element-203" data-mp="12jf2cnpgf9jt">Pro Detail</span>
        </p>
        <div className="h-1 w-24 bg-red-600 mx-auto rounded-full my-6" data-id="element-204" data-mp="12lrt9qd6wu90" />
        <h1 className="text-xl sm:text-2xl font-bold text-gray-200 leading-relaxed" data-id="element-205" data-mp="yhbppvr1tywy">
          Mike’s Pro Detail currently provides mobile detailing services
          throughout Ventura County and Los Angeles County.
        </h1>
      </div>
    </main>;
}